/*eslint-disable */
const $ = window.jQuery = require('jquery');  
import toast from '../../../services/toast';
import countries from '../../../services/country.json';
import allCountries from './phoneCodeList.json';
export default {
  name: 'user-add',
  components: {},
  props: [],
  data () {
    return {
      submitted:false,
      first_name:'',
      last_name:'',
      email:'',
      organization:'',
      division:'',
      area_of_work:'',
      department:'',
      designation:'',
      countryList: [],
      country:'',
      city:'',
      allCountriesList:[],
      phone: {
        number: '',
        isValid: false,
        countryIso: '',
        countryCode:''
      },
      userFilter:'',
      oncologist:false,
      other_doctor:false,
      medical_researcher:false,
      patient:false
    }
  },
  computed: {

  },
  mounted () {
    this.getUserCountry();
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    for (var i = 0; i < allCountries.length; i++) {
      let c = allCountries[i];
      this.allCountriesList.push({
        name: c[0],
        iso2: c[1],
        dialCode: c[2],
        priority: c[3] || 0,
        areaCodes: c[4] || null
      });
    }
    $('.option-list').click(function(e) {
      e.preventDefault();
      $(this).toggleClass('open');
      $(this).find('ul').slideToggle(100);
      if ($(this).hasClass('open')) {
        $('.dropdown-arrow').text('▼');
      } else {
        $('.dropdown-arrow').text('▲');
      }
    });
    $(document).on('click', function(e) {
      var container = $('.option-list');
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass('open');
        $('.dropdown-arrow').text('▲');
        container.find('ul').slideUp(100);
      }
    })
  },
  methods: {
    getUserCountry() {
      var self = this;
      fetch('https://ip2c.org/s')
        .then(function(response) {
          return response.text();
        })
        .then(function(text) {
          if (!text || "1" !== text[0])
            throw new Error("unable to fetch the country");
            self.phone.countryIso = (text.substr(2, 2)).toLowerCase();
            self.phone.countryCode = self.allCountriesList.filter(item => item.iso2 == self.phone.countryIso)[0].dialCode;
        })
        .catch(function(error) {
          console.log('Request failed', error)
        });
    },
    chooseCountry(country) { 
      this.phone.countryIso = country.iso2;
      this.phone.countryCode = country.dialCode
    },
    validateBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
           if(this.userFilter == 'oncologist'){
            this.oncologist = true
           }else if(this.userFilter == 'other_doctor'){
             this.other_doctor = true
           }else if(this.userFilter == 'medical_researcher'){
            this.medical_researcher = true
           }else if(this.userFilter == 'patient'){
            this.patient = true
           }
            let data = {
              email:this.email,
              oncologist:this.oncologist,
              other_doctor:this.other_doctor,
              medical_researcher:this.medical_researcher,
              patient:this.patient
            }
            if(this.first_name != null && this.first_name != ''){
              data.first_name = this.first_name;
            }
            if(this.last_name != null && this.last_name != ''){
              data.last_name = this.last_name;
            }
            if(this.area_of_work != null && this.area_of_work != ''){
              data.area_of_work = this.area_of_work;
            }
            if(this.department != null && this.department != ''){
              data.department = this.department;
            }
            if(this.country != null && this.country != ''){
              data.country = this.country;
            }
            if(this.city != null && this.city != ''){
              data.city = this.city;
            }
            if(this.designation != null && this.designation != ''){
              data.designation = this.designation;
            }
            if(this.division != null && this.division != ''){
              data.division = this.division;
            }
            if(this.phone.countryCode != null && this.phone.countryCode != ''){
              data.mobile_country_code = '+' + this.phone.countryCode;
            }
            if(this.phone.number != null && this.phone.number != ''){
              data.mobile = this.phone.number;
            }
            this.$store.dispatch('createAcUserFun', data)
              .then((res) => {  
                  toast.success(res.data.msg);            
                  this.$router.push({ name: 'usersList'})
              }).catch((err) => {
                toast.error(err.data.data.email || err.data.user_msg || err.data.msg);
              })
            return;
        }
      });
    }
  }
}